import { render } from "./TokenTrade.vue?vue&type=template&id=15d31a54&scoped=true"
import script from "./TokenTrade.vue?vue&type=script&lang=js"
export * from "./TokenTrade.vue?vue&type=script&lang=js"

import "./TokenTrade.vue?vue&type=style&index=0&id=15d31a54&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15d31a54"]])

export default __exports__